export const isVORole = (role) => {
  return role === "VO" || role === "VO_531";
};

export const isVO531Role = (role) => {
  return role === "VO_531";
};

/**
 * LS-738 : colonnes alimentées par le seul import de facturation, figées pour tout le monde
 * dès qu'un import sans anomalie les a validées (seul un super admin déverrouille).
 */
export const FACTURATION_LOCKED_COLUMNS = [
  "vo_date_facture",
  "vo_client_facture",
  "vo_prix_vente_facture",
];

/**
 * Verrou de facturation d'une cellule.
 * @param {string} columnKey - Clé de la colonne
 * @param {Object} item - Le véhicule (avec son occasion)
 * @returns {{locked: boolean, title: string|null}} - Verrouillée ? et libellé à afficher
 */
export const getFacturationLock = (columnKey, item) => {
  const figeeLe = item?.occasion?.facturation_figee_le;

  if (!FACTURATION_LOCKED_COLUMNS.includes(columnKey) || !figeeLe) {
    return { locked: false, title: null };
  }

  const date = new Date(figeeLe).toLocaleDateString("fr-FR");
  const fichier = item?.occasion?.facturation_figee_par_import;

  return {
    locked: true,
    title: `Figé par l'import de facturation du ${date}${
      fichier ? ` (${fichier})` : ""
    }`,
  };
};

/**
 * Filtre l'historique des statuts pour les utilisateurs VO
 * - VO : voir les statuts 51/61 et tous leurs successeurs
 * - VO_531 : voir les statuts 531/561 et tous leurs successeurs
 * @param {Array} statutHistorique - L'historique complet des statuts
 * @param {string} role - Le rôle de l'utilisateur
 * @returns {Array} - L'historique filtré
 */
export const filterStatutHistoriqueForVO = (statutHistorique, role) => {
  return statutHistorique;

  // Si ce n'est pas un rôle VO, retourner l'historique complet
  // if (!isVORole(role)) {
  //   return statutHistorique;
  // }

  // // Définir les statuts de départ selon le rôle
  // const startStatuts = role === "VO_531" ? [531, 561] : [51, 61];

  // // Trier l'historique par date croissante pour traiter chronologiquement
  // const sortedHistorique = [...statutHistorique].sort(
  //   (a, b) => new Date(a.date) - new Date(b.date),
  // );

  // // Trouver l'index du premier statut de départ
  // // Convertir en nombre pour la comparaison (les statuts peuvent être des strings ou des numbers)
  // const startIndex = sortedHistorique.findIndex((item) =>
  //   startStatuts.includes(parseInt(item.statut)),
  // );

  // // Si aucun statut de départ n'est trouvé, retourner un tableau vide
  // if (startIndex === -1) {
  //   return [];
  // }

  // // Retourner tous les statuts à partir du statut de départ (inclus)
  // return sortedHistorique.slice(startIndex);
};

/**
 * LS-742 : libellés des causes d'anomalie de facturation renvoyées par l'API
 * (`anomalies_facturation`, codes de l'enum CauseAnomalieFacturation côté API).
 * @param {Object} item - Le véhicule
 * @returns {string[]} - Libellés lisibles, vide hors anomalie
 */
export const ANOMALIE_FACTURATION_LIBELLES = {
  prix_vente_definitif_manquant: "Prix de vente définitif manquant",
  prix_vente_facture_manquant:
    "Prix facturé manquant (aucune ligne de facturation importée)",
  prix_vente_definitif_different_facture:
    "Prix de vente définitif ≠ prix facturé",
  indemnites_definitif_different_facture: "Indemnités définitif ≠ facturé",
  frais_remise_en_etat_definitif_different_facture:
    "Frais RME définitif ≠ facturé",
  montant_km_supp_definitif_different_facture:
    "Km supplémentaires définitif ≠ facturé",
};

export const getAnomaliesFacturation = (item) => {
  const codes = item?.anomalies_facturation;

  if (!Array.isArray(codes)) {
    return [];
  }

  return codes.map((code) => ANOMALIE_FACTURATION_LIBELLES[code] || code);
};
